import { trackLastPage } from "~/composables/useLastPage"

// Registers the router-wide "page before home" tracking once, at app start — see useLastPage.ts.
export default defineNuxtPlugin(() => {
  trackLastPage(useRouter())
})
